/* eslint-disable react/prop-types */
import Icon from '@/core/icon';
import { _ } from '@/helpers/common';
import { useTranslation } from '@/helpers/translate';

function Item({
  children, className = '', active = false, ...props
}) {
  const classes = active ? 'seo-breadcrumb-link active' : 'seo-breadcrumb-link';
  return (
    <a itemProp="item" className={classes + className} {...props}>
      <span itemProp="name">{children}</span>
    </a>
  );
}

function WrapperItem({ children, pos }) {
  return (
    <li
      itemProp="itemListElement"
      itemScope
      itemType="https://schema.org/ListItem"
      className="seo-breadcrumb-item"
    >
      {children}
      <meta itemProp="position" content={pos} />
    </li>
  );
}

function BreadCrumb(_props) {
  const { t } = useTranslation();
  const {
    items = [], children = [], ...props
  } = _props;

  const elems = [
    ...items.map(({ link, text, active = false }) => (
      <Item
        key={`breadcrumcmsitem${link}${text}`}
        href={link}
        active={active}
      >
        {t(text)}
      </Item>
    )),
    ...children,
  ].reduce((arr, elem, key) => arr.concat(key ? (
    <li key={`separator-${elem.key}`}>
      <Icon name="arrow" className="w-2 h-3 mx-2 fill-current text-purple-5/50" />
    </li>
  ) : null, <WrapperItem key={`wrapper-${elem.key}`} pos={key}>{elem}</WrapperItem>), []);

  return (
    <div className="flex breadcrumb-content">
      <ol
        className="flex items-center py-3 text-xs md:px-0"
        itemScope
        itemType="https://schema.org/BreadcrumbList"
        {..._.omit(props, 'styleLoaded')}
      >
        {elems}
      </ol>
    </div>
  );
}

export default BreadCrumb;
